<template>
    <kt-row>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_config_id">
                    {{ $t('label.merchant_config_id') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_config_id"
                        name="merchant_number"
                        v-model="form_data.merchant_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_id">
                    {{ $t('label.merchant_id') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_id"
                        name="terminal_number"
                        v-model="form_data.terminal_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="usr">
                    {{ $t('label.username') }}
                </kt-form-label>
                <kt-form-control
                        id="usr"
                        name="usr"
                        v-model="port_config.usr"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="3" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="pwd">
                    {{ $t('label.password') }}
                </kt-form-label>
                <kt-form-control
                        id="pwd"
                        name="pwd"
                        v-model="port_config.pwd"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        form_data: {
            required: true
        },
        port_config: {
            required: false
        }
    },
}
</script>

<style>
</style>